export default function () {

    const rmaSwitcher = document.getElementById('rma_type');
    if (!rmaSwitcher) return;

    rmaSwitcher.addEventListener('input', function (event) {
        const params = new URLSearchParams(location.search);
        params.set('type', event.target.value);
        window.location.search = params.toString();
    }, false);

    const submitButton = document.getElementById('rma_submit_button');
    const errorBox = document.getElementById('rma_error');
    const checkboxes = Array.from(document.querySelectorAll("input[name='positionId']"));

    if (!submitButton || checkboxes.length === 0) return;

    submitButton.disabled = true;

    const amountInputs = checkboxes
        .map(cb => ({ checkbox: cb, input: document.getElementById('amount_' + cb.value) }))
        .filter(x => x.input);

    function clamp(input) {
        const max = parseInt(input.dataset.max, 10) || 1;
        let val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        if (val > max) val = max;
        input.value = val;
        return val;
    }

    function refreshValidity() {
        const checkedCount = checkboxes.filter(cb => cb.checked).length;
        submitButton.disabled = checkedCount === 0;
        errorBox.style.display = checkedCount === 0 ? 'block' : 'none';
    }

    function ensureChecked(pair) {
        if (!pair.checkbox.checked) {
            pair.checkbox.checked = true;
            refreshValidity();
        }
    }

    amountInputs.forEach(pair => {
        const wrapper = pair.input.closest('.rma-position-amount');
        const minus = wrapper.querySelector('button.minus');
        const plus = wrapper.querySelector('button.plus');

        const stopBubble = e => e.stopPropagation();
        wrapper.addEventListener('click', stopBubble);

        minus.addEventListener('click', () => {
            const val = clamp(pair.input);
            if (val > 1) pair.input.value = val - 1;
            ensureChecked(pair);
        });

        plus.addEventListener('click', () => {
            const max = parseInt(pair.input.dataset.max, 10) || 1;
            const val = clamp(pair.input);
            if (val < max) pair.input.value = val + 1;
            ensureChecked(pair);
        });

        pair.input.addEventListener('input', () => clamp(pair.input));
        pair.input.addEventListener('blur', () => clamp(pair.input));
        pair.input.addEventListener('focus', () => ensureChecked(pair));

        pair.checkbox.addEventListener('change', refreshValidity);
    });

    import('imask').then(module => {
        amountInputs.forEach(pair => {
            const max = parseInt(pair.input.dataset.max, 10) || 1;
            module.default(pair.input, { mask: Number, min: 1, max });
        });
    });
}
